import React from "react";
import { get, isEmpty } from "lodash";
import { postEvidenceFiles } from "../../apis/evidence-files";
import { getApprobalListByParam } from "../../utils/approval";

const getTask = async ({ mode, defaultData }) => {
  const getTitle = () => {
    return "증빙 자료 업로드";
  };
  const fields = [
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "사유",
      key: "description",
      type: "textarea",
    },
    {
      title: <>매입<br />거래명세서</>,
      className: {
        hide: (mode !== 'create' && isEmpty(get(defaultData, 'data.evidenceFile.purchaseInvoiceFiles', [])))
      },
      titlestyle: {
        lineHeight: '20px'
      },
      key: "purchaseInvoiceFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
    {
      title: <>매출<br />거래명세서</>,
      className: {
        hide: (mode !== 'create' && isEmpty(get(defaultData, 'data.evidenceFile.salesInvoiceFiles', [])))
      },
      titlestyle: {
        lineHeight: '20px'
      },
      key: "salesInvoiceFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
    {
      title: <>지출증빙<br />자료</>,
      className: {
        hide: (mode !== 'create' && isEmpty(get(defaultData, 'data.evidenceFile.expenseFiles', [])))
      },
      titlestyle: {
        lineHeight: '20px'
      },
      key: "expenseFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    title: get(defaultData, 'data.evidenceFile.title', getTitle()),
    description: get(defaultData, 'data.evidenceFile.description', ""),
    purchaseInvoiceFiles: get(defaultData, 'data.evidenceFile.purchaseInvoiceFiles', []),
    salesInvoiceFiles: get(defaultData, 'data.evidenceFile.salesInvoiceFiles', []),
    expenseFiles: get(defaultData, 'data.evidenceFile.expenseFiles', []),
  };

  const create = async ({ description, title, approverEmployees, referenceEmployees, ...form }) => {
    const params = {
      title,
      description,
      approvals: getApprobalListByParam(approverEmployees, referenceEmployees),
    };
    const fileKeys = [
      "purchaseInvoiceFiles",
      "salesInvoiceFiles",
      "expenseFiles",
    ];

    for (const key of fileKeys) {
      if (!isEmpty(form[key])) {
        await postEvidenceFiles({ ...params, [key]: form[key] });
      }
    }
    return Promise.resolve();
  };

  const validate = (form) => {
    let errors = {};
    if (
      isEmpty(form.purchaseInvoiceFiles) &&
      isEmpty(form.salesInvoiceFiles) &&
      isEmpty(form.expenseFiles)
    ) {
      errors.purchaseInvoiceFiles = "셋중 하나는 파일을 업로드해주세요.";
      errors.salesInvoiceFiles = "셋중 하나는 파일을 업로드해주세요.";
      errors.expenseFiles = "셋중 하나는 파일을 업로드해주세요.";
    }
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };
};

export default getTask;